import { render } from "./SubContent.vue?vue&type=template&id=f556214e&scoped=true"
import script from "./SubContent.vue?vue&type=script&lang=js"
export * from "./SubContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f556214e"]])

export default __exports__